module.exports = __webpack_public_path__ + "front/img/edm-logo.675a0824.png";